/* eslint-disable no-param-reassign */
export const EVENTS = {
  ALERT: 'ui.alert',
  START_LOADING: 'ui.startLoading',
  STOP_LOADING: 'ui.stopLoading',
  APP_MOUNTED: 'ui.appMounted',
};

const ui = {
  setup(namespace, root) {
    // setup shortcuts
    // alert(text, options) opens the ErrorSheet (App.vue):
    //   options.kind   'forbidden' (default) | 'network' | 'bluetooth' | 'device'
    //                  picks the illustration
    //   options.action { label, event }: a primary button that emits `event`
    //                  on this bus when tapped, e.g. hardware.showBTSettings
    root.alert = (text = '', options = {}) => {
      root.emit(EVENTS.ALERT, text, options);
    };
    root.startLoading = (hideUI = false) => {
      root.emit(EVENTS.START_LOADING, hideUI);
    };
    root.stopLoading = () => {
      root.emit(EVENTS.STOP_LOADING);
    };
  },
};

export default ui;
